import { render, staticRenderFns } from "./flightMonitor.vue?vue&type=template&id=51678234&scoped=true&"
import script from "./flightMonitor.vue?vue&type=script&lang=ts&"
export * from "./flightMonitor.vue?vue&type=script&lang=ts&"
import style1 from "./flightMonitor.vue?vue&type=style&index=1&id=51678234&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51678234",
  null
  
)

export default component.exports